(function () {
    'use strict';

    angular.module("product")
        .controller('ProductOptionsGroupAddModalController', ProductOptionsGroupAddModalController);

    ProductOptionsGroupAddModalController.$inject = ['product', 'optionsGroups', '$uibModalInstance'];

    function ProductOptionsGroupAddModalController(product, optionsGroups, $uibModalInstance) {
        var self = this;

        self.selectedGroups = {
            options_group_pks: []
        };

        self.optionsGroups = optionsGroups;

        self.ok = ok;

        function ok() {
            $uibModalInstance.close(
                self.optionsGroups.filter(function(item) {
                    return self.selectedGroups.options_group_pks.indexOf(item.pk) !== -1;
                })
            );
        }
    }
})();
